import { createSlice } from '@reduxjs/toolkit';
import { getQuery } from '../../../../../../../scripts/util/getQuery';

export const waitCardsItemsSlice = createSlice({
  name: 'waitCards',
  initialState: {
    isFetching: false,
    waitTimes: {}
  },
  reducers: {
    getWaitCardsItems: state => {
      state.isFetching = true;
    },
    getWaitCardsItemsSuccess: (state, action) => {
      state.isFetching = false;
      if (action.payload) {
        state.waitTimes[action.payload.hospital_id] = action.payload.hospital_waits.current_wait;
      }
    }
  }
});

export default waitCardsItemsSlice.reducer;

const {
  getWaitCardsItems,
  getWaitCardsItemsSuccess
} = waitCardsItemsSlice.actions;

const getWaitCardsItemsData = (params) => {
  const {
    hospitalId
  } = params;

  return async (dispatch) => {
    dispatch(getWaitCardsItems());
    return fetch(new Request(`https://api.clockwisemd.com/v1/hospitals/${hospitalId}/waits`, {
      method: 'GET'
    }))
      .then(response => response.json()).then(json => {
        dispatch(getWaitCardsItemsSuccess(json));
      });
  };
};

export { getWaitCardsItemsData };